<template>
  <div>
    <el-card>
      <el-form label-width="220px" :model="form" ref="form" :rules="embrRules" class="embrForm" @submit.native.prevent>
        <el-form-item label="电绣片数：" prop="rfid_embr_phr">
          <el-input
            v-model="form.rfid_embr_phr"
            ref="embr_phrRef"
            maxlength="9"
            show-word-limit
            @input="form.rfid_embr_phr = keepNum99(form.rfid_embr_phr)"
          >
            <template slot="append">片</template>
          </el-input>
        </el-form-item>
        <el-form-item label="贴布片数：" prop="rfid_app_phr">
          <el-input v-model="form.rfid_app_phr" maxlength="9" show-word-limit @input="form.rfid_app_phr = keepNum99(form.rfid_app_phr)">
            <template slot="append">片</template>
          </el-input>
        </el-form-item>
        <el-form-item label="填卡人：" prop="card_user_id">
          <el-select v-model="form.card_user_id" filterable placeholder="请选择" disabled>
            <el-option v-for="item in stffList" :key="item.user_id" :label="item.stff_name" :value="item.user_id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="制作人：" prop="stff_id">
          <el-select v-model="form.stff_id" filterable placeholder="请选择">
            <el-option v-for="item in stffList2" :key="item.stff_id" :label="item.stff_name" :value="item.stff_id"> </el-option>
          </el-select>
        </el-form-item>
        <sub-table ref="subTable" :stffList="stffList2" />
        <el-form-item class="ml_10" align="center">
          <el-button type="success" class="determine" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!--   提交 -->
    <el-dialog :visible.sync="embrDialogVisible" width="70%">
      <h2 class="diaTitle">提示：提交电绣信息, 是否继续</h2>
      <div class="diaContent">
        <el-button @click="embrDialogVisible = false" class="determine">取 消</el-button>
        <el-button type="primary" @click="embrDialog" class="determine">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from '@api/request';
import { rfidAPI } from '@api/modules/rfid';
import helper from '@assets/js/helper';
import SubTable from '@/views/OperateManagement/ReadManage/TabChild/subTable.vue';

export default {
  components: { SubTable },
  data() {
    return {
      form: {
        rfid_embr_phr: '',
        rfid_app_phr: '',
        card_user_id: '',
        stff_id: ''
      },
      embrRules: {
        rfid_embr_phr: [
          { pattern: /^[0-9]*$/, message: '只能输入零和正整数!' },
          { required: true, message: '请输入电绣数量', trigger: 'blur' }
        ]
      },
      embrDialogVisible: false
    };
  },
  props: {
    prop: {
      type: Object
    },
    stffList: {
      type: Array
    },
    stffList2: {
      type: Array
    }
  },
  methods: {
    submit() {
      if (!this.prop.rfid_id) {
        return this.$message.error('请刷卡');
      }
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.embrDialogVisible = true;
        }
      });
    },
    embrDialog() {
      this.embrDialogVisible = false;
      let form = {};
      form.rfid_id = this.prop.rfid_id;
      form.user_id = this.prop.user_id;
      // form.stff_id = this.prop.stff_id;
      // form.stff_name = this.prop.stff_name;
      form.rfid_embr_phr = this.form.rfid_embr_phr;
      form.rfid_app_phr = this.form.rfid_app_phr;
      form.card_user_id = this.form.card_user_id ? this.form.card_user_id : this.$cookies.get('userInfo').user_id;
      form.stff_id = this.form.stff_id ? this.form.stff_id : this.$cookies.get('userInfo').stff_id;
      form.stff_name = this.stffList2.find(item => item.stff_id === form.stff_id).stff_name;
      form.user_id = this.stffList.find(item => item.stff_id === form.stff_id).user_id;
      form.user_rfid_no = this.prop.user_rfid_no;
      form.list = this.$refs.subTable.tableData.filter(x => (x.rfid_embr_id ? true : !x.rfid_embr_id && !x.destroy_flag));
      post(rfidAPI.edit_embr, form)
        .then(res => {
          if (res.data.code !== 0) {
            return this.$message.error(res.data.msg);
          }
          this.$message.success(res.data.msg);
          this.$refs['form'].resetFields();
          this.$emit('empty');
        })
        .catch(res => {
          this.$message.error(res.data.msg);
        });
    },
    embrKeyup() {
      this.$refs.embr_phrRef.focus();
    },
    keepNum99(val) {
      let keepTNum = Number(helper.keepTNum(val));
      if (keepTNum > 99) {
        this.$message.warning('输入范围0～99超出最大限度');
        return 99;
      } else {
        return keepTNum;
      }
    }
  },
  mounted() {
    this.$EventBus.$on('embr', () => {
      this.form.rfid_embr_phr = '';
      this.form.rfid_app_phr = '';
      this.form.card_user_id = '';
      this.form.stff_id = '';
    });
    this.$EventBus.$on('embrEmit', res => {
      this.form.rfid_embr_phr = res.rfid_embr_phr;
      this.form.rfid_app_phr = res.rfid_app_phr;
      this.form.card_user_id = res.card_user_id;
      this.form.stff_id = res.stff_id;
      if (this.$refs.embrRef) this.$refs.embrRef.focus();
    });
  }
};
</script>

<style lang="scss" scoped>
.embrForm .el-form-item {
  margin-bottom: 10px;
}
.embrForm {
  width: 90%;
  margin: 0 auto;
  min-width: 500px;
}
::v-deep .embrForm .el-form-item__label {
  font-size: $font-max;
}
::v-deep .embrForm .el-input {
  font-size: $font-max;
  height: 60px;
}
::v-deep .embrForm .el-input input {
  height: 60px;
}
::v-deep .el-form-item__error {
  font-size: 18px;
  margin-bottom: 2px;
}
</style>
